import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles/styles.scss';

const BadgeImage = (props) => {
    const { image } = props;
    return (
      <div className="badge-custom badge-image">
        <div className="badge-content">
          <img src={image} alt="badge"/>
        </div>
      </div>
    );
  }


BadgeImage.propTypes = {
  image: PropTypes.string,
};

export default BadgeImage;
